import { ISite } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/api/admin/agent/sites';

interface IRequest {
  securityKey: string;
}

interface IResult {
  sites: ISite[];
  rootSiteId: number;
}

export default {
  getSites(hostName: string, nodeName: string, isHongKong: boolean, req: IRequest, success: (res: IResult) => void) {
    utils.loading(true);
    const hostRequest = utils.getHostRequest(hostName, nodeName, isHongKong);
    hostRequest
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
